import styled from 'styled-components';
import colors from 'constants/colors';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 348px;
  margin-top: 185px;

  .brand {
    margin-top: 11px;
    color: ${colors.white};
    .rook {
      font-size: 33px;
      font-weight: bold;
    }

    .hotel {
      font-size: 33px;
      font-weight: 300;
    }
  }

  .title {
    margin-top: 72px;
    color: ${colors.lightBlue};
    font-size: 24px;
    font-weight: 600;
  }


  .highlight {
    margin-top: 16px;
    font-size: 16px;
    color: ${colors.lightBlue};
    cursor: pointer;
  }
  
  .errorMessage {
    width: 100%;
    margin-bottom: 17px;
    color: ${colors.red};
    align-items: flex-start;
  }

  .password {
    position: relative;
    width: 100%;

    .passwordLock,
    .passwordUnlock {
      position: absolute;
      top: 55px;
      right: 12px;
      cursor: pointer;
    }
  }
`;